<script lang="ts">
	import { dev } from '$app/environment';
	import { page } from '$app/stores';
	import { translations } from '$lib/i18n/translations';
	import type { Property } from '$lib/satellite.types';

	const property = $page.data.property as Property;
	const colors = property.colors;
	const t = translations($page.data.property.language);

	let newsletterBanner: HTMLDivElement;
	let form: HTMLFormElement;
	let success: HTMLDivElement;

	const setCookie = () => {
		if (!dev) {
			document.cookie = `newsletterBanner=1; path=/; max-age=${60 * 60 * 24 * 30};`;
		}
	};

	const hide = () => {
		newsletterBanner.classList.add('hidden');
		setCookie();
	};

	const addGoLoot = () => {
		const wrapper = document.createElement('div');
		wrapper.dataset.golootWrapper = '1';
		wrapper.classList.add('flex', 'justify-center');
		const script = document.createElement('script');
		script.src = 'https://rewards.goloot.io/gl-formats.js';
		script.dataset.integration_id = property.newsletter?.golootId;
		script.dataset.responsive = '';
		wrapper.appendChild(script);
		success.appendChild(wrapper);
	};

	const sendGAEvent = () => {
		if (!window.gtag) {
			return;
		}
		window.gtag('event', 'sign_up', {
			method: 'newsletter'
		});
	};

	const submit = (event: Event) => {
		event.preventDefault();
		const form = event.target as HTMLFormElement;
		const email = form.email.value;

		const listId = property.newsletter?.listId;

		if (!dev) {
			fetch('/api/newsletter', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ email, listId })
			});
		}

		//const h: number = form.getBoundingClientRect().height;
		//success.style.height = `${h}px`;

		form.classList.add('hidden');
		success.classList.remove('hidden');

		addGoLoot();

		setCookie();

		sendGAEvent();
	};
</script>

<div
	bind:this={newsletterBanner}
	class="w-full bg-gray-50 bg-repeat-x relative print:hidden"
	style="background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAO8AAAAZCAYAAADZu3m9AAAACXBIWXMAAAWJAAAFiQFtaJ36AAAENElEQVR4nO2c3W8UVRiH32XabTuz9mu7dHHZ7rRZE1ipJAViGi5auTCBVAOY2NiQcEEjiICURP8FEVguQCB6U7SGGI0GFYPBsJDKTYNKDB+BNkt3aLftstNdWjqz293ODldcCqGdOe+ZvDx/wJ7fZuZ5z8ecc1ymaZrAiGmtoH78440GVu1hIteLcPjdVuwYzBgf6FfSl/4IYedggSBK0Hrqq7yrrLwSMcZby1i2duqvOAlxAQB2b2x5hJ2BFTklAVTEBQAI9OxQkcUFAABm8g7G1eSdqVlWzaGyJeKHZq9Ui52DFYnTJ5LYGVhRFZLB27GJi06IibxFo5T/ZigRYNEWNpJbgA/WBeexc7BCjf05nZ9Ikni2AAAtfZ+p2BmewkTe/iHF1AoGi6bQ6W1vnisXllVg52CBoWsw/m1/FXYOVjS+szXr9nq56HUBGMirZHQ1NvyQxAOO+Kuhvdnrwc7BisTpk2OmYYjYOVjgbvDBivfe56oo2y7vsdgwN5XKbg52hnXsDKx4fPuWNvvfjSB2DlaEPtyrugSBq0Jlq7y/3pyYSc/RmP51t62cr64s5+rh2snoyeML2BlY8crrazTP6gh3nZBt8mqFhZlfbk7U2PX7POHzVMC2NwJcDansJHluIGVoGolnK4gSNO8/xGWhsk3eaGykhsoi1Sed4TnsDKwoqGlIX7pIZl7v37o9JUgSl4XKFnnvTM2qVL7pbmiqg3CDh8zLHI9+kTINQ8LOwYKqkAzLN3c1Yuf4PyyXd6Fk5qJEFqkktwAHOsI0JvUA8Oj6kJ4fH+P2ZbYaec++FHaGZ2G5vN//O+aiMlzubgvOU/qmq3x9JoedgxXezk25ypVBrguVpfJOawX1wq1J9D2fLJDrRXh7VSMJcQEAxgfOJkv5nBc7BwsEUYLgzl3YMZ6LpfIevXyPxHAZAOBg52tkFqlySgIy1wbJbIEM7d6bcpWVcb+xyDJ5r4yk1USGxh6FLRE/+KsrCS1SHeZ67mclntURqGlbz/Vw+SmWyFs0Svnvriskel2fp4LUwYPUb+ezxWzWES+zFcgfHXBMobJE3i8H4yUqi1S97bJOaZFq8qcf3Ng5WPFqd89MeV2dYwrVkuVVMro6pGRIbAuM+KthbaCWxH8FALh//MgUlW+67gYfLN/cVYad40VYkrxGydSpHDyQ3AK5gwdz9+76sXOwoqXvU9UlCI4qVEuS9/fbk0UqBw+61qwgc/DA0DUYPREtYOdgRe2GN/WqppDjOqFFy6sVFmbO/TPG5Z5Pq5HrRVIHD6bO/5wydL0OOwcLBFGCpt49juyBFi1vNDZCQlwAWpfJFdQ0PLx4wTGLNksl0LNDFUTRkYVqUfL+/SCbonLwoCPsI3WZXPzo5y8vk3MILyxv0Sjlz1yLk6jMkluA3nbZkUOqxTB9NZZ7eZmcc3gCrzVflJwmjkgAAAAASUVORK5CYII='); background-size: 2rem; background-position: bottom;"
>
	<button class="absolute top-2 right-2 p-1" on:click={hide}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			class="w-6 h-6"
		>
			<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
		</svg>
	</button>

	<div class="pt-4 pb-6">
		<div class="max-w-screen-lg px-4 xl:px-0 mx-auto">
			<div class="text-center mb-3">
				<h2 class="text-2xl font-semibold text-gray-900">{property.newsletter?.title}</h2>
				<p class="mt-1 text-sm text-gray-500">
					{property.newsletter?.subtitle}
				</p>
			</div>
			<div bind:this={success} class="hidden">
				<!--
				<div class="flex h-full w-full items-center gap-1 text-green-700 justify-center">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="w-6 h-6 inline-block"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
						/>
					</svg>
					<span>{t('newsletterSignupSuccess')}</span>
				</div>
				-->
			</div>
			<form bind:this={form} on:submit={submit}>
				<div
					class="max-w-lg flex-col lg:flex-row flex items-center justify-between gap-3 lg:gap-4 mx-auto"
				>
					<input
						type="email"
						name="email"
						required
						class="block w-full lg:w-auto grow rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:{colors.ring} sm:text-sm sm:leading-6"
						placeholder={t('newsletterPlaceholder')}
						autocomplete="on"
					/>
					<button
						type="submit"
						class="rounded-md {colors.background} hover:{colors.hoverBackground} px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500"
					>
						{t('newsletterSubscribe')}
					</button>
				</div>
				<small class="max-w-lg mx-auto block mt-3 text-xs text-center text-gray-400">
					<!-- eslint-disable-next-line svelte/no-at-html-tags -->
					{@html t('newsletterLegal', {
						startLink:
							'<a class="underline hover:text-gray-500" href="/informations/politique-de-confidentialite">',
						endLink: '</a>'
					})}
				</small>
			</form>
		</div>
	</div>
</div>

<style>
	:global(body.newsletter-banner) {
		padding-top: 80px;
	}
</style>
